<!-- 选择岗位 -->
<template>
    <el-dialog v-dialogDrag :title="title" :visible.sync="dialogVisible" width="550px" top="200px"
        :modal-append-to-body="false">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="岗位类型：" prop="valueArr">

                <!-- 添加change事件监听 -->
                <el-cascader ref="positionTypeRef" v-model="ruleForm.valueArr" :options="options" style="width: 100%;"
                    :show-all-levels="false" clearable :props="{
                        checkStrictly: true,
                        value: 'dict_id',
                        label: 'dict_name',
                    }" filterable @change="handleChange"></el-cascader>

            </el-form-item>
        </el-form>

        <!-- v-if  从新渲染 -->
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleOk">确 定</el-button>
            <el-button @click="dialogVisible = false">取 消</el-button>

        </span>
    </el-dialog>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {
            dialogVisible: false,
            title: '选择适用岗位',
            formData: {
                "key": "",
                "value": ""  // 添加存储label的字段
            },

            ruleForm: {
                valueArr: [],
              
            },
            options: [],
            rules: {
                valueArr: [
                    { required: true, message: '请选择', trigger: 'blur' },

                ],

            }
        }
    },
    created() {

    },
    methods: {
        // 获取职位类型级联下拉
        getPostionTypeOptions() {
            this.$tools
                .asyncPost(this, this.$baseUrl.hierdictlist, {})
                .then((res) => {
                    if (res.data.code == 0) {
                        this.options = res.data.data;
                    } else {
                        // this.$message({ type: "error", message: res.data.msg });
                    }
                })
                .catch((err) => {
                    // this.$message({ type: "error", message: err });
                });
        },
        init() {
            this.dialogVisible = true
            this.formData={
                "key": "",
                "value": ""  // 添加存储label的字段
            },
            this.getPostionTypeOptions()
            this.ruleForm = {
                valueArr: [],
            }
        },
        handleClose(done) {

            done();

        },
        handleOk() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {


                    let obj = {
                        ...this.formData,

                    }

                    this.$emit('ok', obj)
                    this.dialogVisible = false
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        recursion(arr) {
            let obj;
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].options) {
                    obj = this.recursion(arr[i].options)
                    if (obj) {
                        return obj
                    }
                }
                if (arr[i].enterprise_id && arr[i].enterprise_id == this.ruleForm.enterprise_id) {
                    // obj = arr[i]

                    return arr[i];
                }
            }

        },
        // 修改handleChange方法获取label
        handleChange(value, selectedOptions) {
            // 获取节点下的汉字

            // selectedOptions是选中的节点数组，最后一项是当前选中节点
            if (value && value.length > 0) {
                let arr = [];
                let data = this.$refs.positionTypeRef.getCheckedNodes()[0].pathLabels.toString();
                arr = data.split(",");
                this.formData.key = value[value.length - 1];

                this.formData.value = arr[arr.length - 1];
                console.log('选中的值:', this.ruleForm.key);

                console.log('选中的label:', this.ruleForm.value);
            } else {
                this.formData.key = ''; // 清空选择时重置label
                this.formData.value = '';// 清空选择时重置label
            }
        },

        getOptions() {


            this.$tools
                .asyncPost(
                    this,
                    this.$baseUrl.trainingOutlineTree, {
                    data: this.postForm3
                }).then((res) => {
                    if (res.data.code == 0) {
                        res.data.data.forEach(item => {
                            item.fold = true
                        })
                        this.options = res.data.data


                    } else {
                        this.$message({ type: "error", message: res.data.msg });
                    }
                    this.loading = false;
                }).catch((err) => { this.loading = false; });
        },
    }
}
</script>

<style lang="less" scoped></style>